import { array } from "../../shared/src/codecs/types/array";
import { boolean } from "../../shared/src/codecs/types/boolean";
import { intersection } from "../../shared/src/codecs/types/intersection";
import { literal } from "../../shared/src/codecs/types/literal";
import { nullCodec } from "../../shared/src/codecs/types/nullCodec";
import { required } from "../../shared/src/codecs/types/required";
import { string } from "../../shared/src/codecs/types/string";
import { union } from "../../shared/src/codecs/types/union";
import { uuid } from "../../shared/src/codecs/types/uuid";

export const UserVideoVerificationCall1 = required({
    video_verification_call_id: uuid(),
    user_id: string(),
});
export type TUserVideoVerificationCall1Codec = typeof UserVideoVerificationCall1;

// Wide outcome union so row-read codecs decode both call_types; per-row UI validity is filtered at the dropdown layer.
export const UserVideoVerificationCall3 = required({
    outcome: union([
        literal("unknown"),
        literal("pass"),
        literal("fail"),
        literal("did_not_show"),
        literal("needs_video_call"),
        literal("unreachable"),
    ]),
});

export const UserVideoVerificationCall5 = required({
    client_understood: union([nullCodec(), boolean()]),
    client_not_distracted: union([nullCodec(), boolean()]),
    vulnerability_concerns: union([literal("unknown"), literal("none"), literal("yes_concerns")]),
    vulnerability_concerns_details: string(),
});
export type TUserVideoVerificationCall5Codec = typeof UserVideoVerificationCall5;

export const UserVideoVerificationCall2 = intersection([
    required({
        id: uuid(),
    }),
    UserVideoVerificationCall3,
    UserVideoVerificationCall5,
]);
export type TUserVideoVerificationCall2Codec = typeof UserVideoVerificationCall2;

export const UserVideoVerificationCall4 = required({
    user_ids: array(uuid()),
});

export const UserVideoVerificationCallPassed = required({
    outcome: literal("pass"),
});
